import { UPDATE_SETTINGS } from '../actions/settingsActions';

import { splitPhoneNumber } from '../utils';

const initSettingssState = {
  phone: '09087493044',
  formattedPhone: '0908-749-3044',
  email: 'support@buypower.ng',
  states: [
    { code: 1, name: 'ABUJA' },
    { code: 17, name: 'LAGOS-IKEJA' },
    { code: 18, name: 'LAGOS-EKO' },
    { code: 9, name: 'KADUNA' },
    { code: 13, name: 'RIVERS' },
    { code: 19, name: 'OYO' },
    { code: 5, name: 'PLATEAU' },
    { code: 7, name: 'BAUCHI' },
    { code: 21, name: 'OGUN' },
    { code: 6, name: 'BENUE' },
    { code: 22, name: 'KWARA' },
    { code: 3, name: 'KOGI' },
    { code: 8, name: 'GOMBE' },
    { code: 14, name: 'BAYELSA' },
    { code: 11, name: 'KEBBI' },
    { code: 15, name: 'CROSS-RIVER' },
    { code: 4, name: 'NASSARAWA' },
    { code: 2, name: 'NIGER' },
    { code: 10, name: 'SOKOTO' },
    { code: 20, name: 'OSUN' },
    { code: 12, name: 'ZAMFARA' },
    { code: 16, name: 'AKWA-IBOM' },
    { code: 23, name: 'ENUGU' },
    { code: 24, name: 'ANAMBRA' },
    { code: 25, name: 'IMO' },
    { code: 26, name: 'ABIA' },
    { code: 188, name: 'Abia State, Aba' },
    { code: 27, name: 'EBONYI' },
    { code: 28, name: 'EDO' },
    { code: 29, name: 'DELTA' },
    { code: 30, name: 'ONDO' },
    { code: 31, name: 'EKITI' },
    { code: 32, name: 'ADAMAWA' },
    { code: 33, name: 'YOBE' },
    { code: 34, name: 'TARABA' },
    { code: 35, name: 'BORNO' },
    { code: 36, name: 'KANO' },
    { code: 37, name: 'JIGAWA' },
    { code: 38, name: 'KATSINA' },
  ],
};

export default (state = initSettingssState, action) => {
  switch (action.type) {
    case UPDATE_SETTINGS:
      return {
        ...state,
        ...action.data,
        formattedPhone: splitPhoneNumber(action.data.phone || initSettingssState.phone),
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/settingsReducer.js